import { Box, keyframes } from "@mui/material";
import { useState } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import ReactTooltip from "react-tooltip";

import { P1, Span, TableFilterIcon } from "@/Components";
import { SortRadioWithTwoOption } from "@/Components/Checkbox";
import { useInfo } from "@/context/InfoProvider/InfoProvider";
import { colors } from "@/Utils";

const slideInFromTop = keyframes`
  0% {
    transform: translateY(-60%);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
`;

const SortSection = ({ sortCheckbox = {}, handleSortCheckbox }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const { theme: colorTheme } = useInfo();

  const handleTooltip = () => {
    setTooltipOpen(!tooltipOpen);
  };

  let sortRadioStatus = Object.keys(sortCheckbox);

  return (
    <Box
      sx={{
        width: "40px",
        position: "relative",
      }}
    >
      {tooltipOpen ? (
        <OutsideClickHandler onOutsideClick={handleTooltip}>
          <Box
            sx={{
              position: "absolute",
              left: "initial",
              right: "-5px",
              top: "-15px",
              maxWidth: "300px",
              width: "220px",
              filter: `drop-shadow(0px 5px 5px ${colors.black})`,
              animation: `0.3s ease-out 0s 1 ${slideInFromTop}`,
              zIndex: 2000,
              display: "block",
              "& svg": {
                cursor: "pointer",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                backgroundColor: colorTheme.mode === "dark" ? colors.gray : colors.secondaryColor,
                zIndex: 9,
                padding: "15px 5px 15px 17px",
                clipPath: `polygon(
                  0% 0px,
                  0px 0%,
                  0px 0%,
                  100% 0px,
                  100% calc(100% - 20px),
                  calc(100% - 20px) 100%,
                  0px 100%
                )`,
                "& svg": {
                  cursor: "pointer",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                <P1 fSize={12} fweight={600}>
                  Sort Graph
                </P1>
                <TableFilterIcon onClick={handleTooltip} />
              </Box>
              {sortRadioStatus.map((item, index) => {
                return (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      width: "100%",
                      marginTop: "10px",
                      marginBottom: 0,
                    }}
                  >
                    <SortRadioWithTwoOption
                      id={`filter-checkbox-${index}`}
                      status={sortCheckbox[item]}
                      colorTheme={colorTheme}
                      label={item}
                      onChange={() => handleSortCheckbox(item, sortCheckbox[item])}
                    />
                  </Box>
                );
              })}
            </Box>
          </Box>
        </OutsideClickHandler>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            alignItems: "center",
            width: "100%",
          }}
        >
          <ReactTooltip
            arrowColor="transparent"
            backgroundColor={colorTheme.mode === "dark" ? colors.darkGray : colors.secondaryColor}
            place="left"
            id={`review-all-revenue-filter`}
            type="dark"
            className="react-tooltip-custom"
          >
            <Span fSize={13} pdtop={5}>
              Sort Graph
            </Span>
          </ReactTooltip>
          <TableFilterIcon
            onClick={handleTooltip}
            data-tip
            data-for={`review-all-revenue-filter`}
          />
        </Box>
      )}
    </Box>
  );
};

export default SortSection;
